'use client'

export const FacilityButton = ({
	name,
	Icon,
	isSelected,
	onClick,
	previewMode,
}: {
	name: string
	Icon: React.FC<{ className?: string }>
	isSelected?: boolean
	onClick?: () => void
	previewMode?: boolean
}) => (
	<button
		type="button"
		onClick={onClick}
		className={`box-border flex w-max items-center gap-2 ring-inset ${
			isSelected
				? 'text-blue ring-2 ring-blue'
				: 'text-dark-grey ring-1 ring-border-grey'
		} ${previewMode ? 'pointer-events-none rounded-4 px-2 py-1 text-body-caption' : 'type-body-small rounded-8 p-2 transition-all duration-200 hover:border-grey hover:ring-2'} `}
	>
		<Icon className={previewMode ? 'size-4' : 'size-6'} />
		{name}
	</button>
)
